import { dropdownIcon, locationSearchIcon } from "assets/icons";
import Placeholder from "components/placeholder/Placeholder";
import React, { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { Link } from "react-router-dom";
import { mySiteApi } from "services/mySites";
import { SitesListShimmer } from "shimmer/mySites/SitesListShimmer";
import { capitalize } from "utils/commonFun";
import { failMessage } from "utils/toastMessage";

const MySites = ({ title = 'My Sites', cardIcon = locationSearchIcon, navigate = '/sites/details' }) => {
  const [sites, setSites] = useState([])
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  // console.log('sites', sites)
  //--------site-listing--------------
  const mySiteList = async (page = 1, isRefresh = false) => {
    try {
      setLoading(true)
      const res = await mySiteApi({
        limit: 12,
        page,
      })
      if (res?.status === 200) {
        const data = res?.data?.data
        if (isRefresh) {
          setSites(data || []);
        } else {
          setSites((prev) => [...prev, ...(data || [])]);
        }
        setHasMore(data.length === 12);
      } else {
        failMessage(res)
      }
    } catch (e) {
      console.log('error', e?.message)
    } finally {
      setLoading(false)
    }
  }


  useEffect(() => {
    setPage(1);
    setHasMore(true);
    mySiteList(1, true);
  }, []);

  // const fetchMoreData = () => {
  //   setPage((prevPage) => {
  //     const nextPage = prevPage + 1;
  //     mySiteList(nextPage);
  //     return nextPage;
  //   });
  // };
  const fetchMoreData = () => {
    if (!hasMore) return;
    const nextPage = page + 1;
    setPage(nextPage);
    mySiteList(nextPage);
  };

  return (
    <div className="my_sites">
      <h3 className="title">{title}</h3>
      <div className="sitesList">
        <InfiniteScroll
          dataLength={sites.length}
          next={fetchMoreData}
          hasMore={hasMore}
          loader={<SitesListShimmer count={1} />}
        >
          {(!loading && sites.length === 0) ? (
            <Placeholder title={"No data Found"} />
          ) : (
            <ul>
              {sites.length > 0 && sites.map((data, ind) => (
                <li key={ind}>
                  <Link to={`${navigate}/${data?.siteName}/${data?._id}`}></Link>
                  <img src={cardIcon} alt="" className="location_icon" />
                  <p>
                    <span>{data?.siteName || "N/A"}</span>
                    <small>
                      {data?.projectCity && data?.projectState
                        ? `${capitalize(data.projectState)}, ${capitalize(data.projectCity)}`
                        : "N/A"}
                    </small>
                  </p>
                  <img src={dropdownIcon} alt="" className="dropdown_icon" />
                </li>
              ))}
            </ul>
          )}
        </InfiniteScroll>

      </div>
    </div>
  );
};
export default MySites;
